import _get from 'lodash/get'
import { appId } from '@/config'

export function data() {
  const theme = _get(this, ['$store', 'state', 'theme'], {})

  const height = 85
  const width = 200
  const color = '#91909a'

  return {
    appId,

    expand: true,

    activeColor: '#2cabe1',

    width,

    theme,
    icon: {
      stroke: color
    },
    label: {
      style: {
        color,
        paddingLeft: '12px',
        cursor: 'pointer'
      }
    },
    currentPath: '',
    styles: {
      crate: {
        position: 'fixed',

        top: height + 'px',
        left: `-${width}px`,

        width: `${width}px`,
        height: `calc(100vh - ${height}px)`,
        minHeight: '-webkit-fill-available',

        transform: 'translateX(0px)',
        transition: 'transform .4s'
      }
    }
  }
}
